import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import { useEffect } from "react";
import { TIEJUN_LEVELS, TIEJUN_LEVEL_MAP } from "src/config/constants";
import TiejunPicker from "src/components/common/TiejunPicker";

const levels = Object.values(TIEJUN_LEVELS);

// console.log(levels, TIEJUN_LEVEL_MAP)

const TiejunAddDialog = ({ action, staff, open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    uid: "",
    // level: 1,
    mobile: "",
    realname: "",
    idNo: "",
  });

  const [user, setUser] = useState({});
  const [parent, setParent] = useState({});

  useEffect(() => {
    if (action !== "edit") return;

    setForm({
      uid: staff.uid,
    });
    setUser(staff);
  }, [staff]);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (!user.uid) return alert("请选择用户");
    // if (!parent.id) return alert("请选择辅导员");
    if (!form.realname || !form.mobile) return alert("请填写完整信息");

    const { msg } = await asyncRequest({
      path: "/user/tiejun/add",
      data: {
        ...form,
        uid: user.uid,
        pid: parent.id,
      },
    });

    alert(msg, "success");
    onUpdate();
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        setUser(val);
        setForm({
          ...form,
          mobile: val.mobile || "",
        });
      },
    });
  }

  function handleSelectTiejun() {
    TiejunPicker({
      onSelect(val) {
        console.log(val);
        setParent(val);
      },
    });
  }

  return (
    <FormDialog title="添加铁军" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <Stack onClick={handleSelectUser}>
          <UserInfo {...user} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="真实姓名" required>
        <TextField fullWidth value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
      </FormItem>

      <FormItem title="手机号" required>
        <TextField fullWidth value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
      </FormItem>

      <FormItem title="身份证号" required>
        <TextField fullWidth value={form.idNo} size="small" onChange={(e) => handleIptChange("idNo", e.target.value)} />
      </FormItem>

      <FormItem title="辅导员">
        <Stack direction="row" alignItems="center" spacing={2} onClick={handleSelectTiejun}>
          <UserInfo {...(parent.user || {})} enablePreview={false} />
        </Stack>
      </FormItem>
    </FormDialog>
  );
};

export default TiejunAddDialog;
